import { deleteApi, getApi, postApi, putApi } from "./http.service";

export const getAllProducts=async(payload:any)=>{
    return getApi('product/list',payload);
}

export const createNewProduct=async(payload:any)=>{
    return postApi('product',payload);
}

export const getProductById=async(id:any)=>{
    return getApi('product/'+id);
}

export const updateProductById=async(id:any, payload:any)=>{
    return putApi('product/'+id, payload);
}

export const deleteProductById=async(id:any)=>{
    return deleteApi('product/'+id);
}